import React from 'react';
import './styles.sass';

interface EmailNotValidatedModalProps {
    message: string;
    instructions?: string[];
    supportMessage?: string;
    canResendEmail?: boolean;
    resendingEmail: boolean;
    onResend: () => void;
}

export const EmailNotValidatedModal: React.FC<EmailNotValidatedModalProps> = ({
    message,
    instructions,
    supportMessage,
    canResendEmail,
    resendingEmail,
    onResend
}) => {
    return (
        <div className="email-not-validated-modal">
            <p className="message">{message}</p>
            
            {instructions && instructions.length > 0 && (
                <div className="instructions-box">
                    <p className="instructions-title">O que fazer:</p>
                    {instructions.map((instruction: string, index: number) => (
                        <p key={index} className="instruction-item">
                            {index + 1}. {instruction}
                        </p>
                    ))}
                </div>
            )}
            
            {canResendEmail && (
                <div className="resend-section">
                    <p className="resend-prompt">Não recebeu o email?</p>
                    <button
                        className="resend-button"
                        onClick={onResend}
                        disabled={resendingEmail}
                        aria-label="Reenviar email de verificação"
                        aria-busy={resendingEmail}
                    >
                        {resendingEmail ? '⏳ Enviando...' : 'Reenviar Email de Verificação'}
                    </button>
                </div>
            )}
            
            {supportMessage && (
                <p className="support-message">{supportMessage}</p>
            )}
        </div>
    );
};

